import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import BudgetTable from "../../BudgetTable";

import Slider from "./Slider";
import MediaQuery from "react-responsive";

const budget = {
  header: [
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
    "2023-2024",
  ],
  rows: {
    row1: [
      "Satellite Data",
      "19.8",
      "150.0",
      "150.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "319.8",
    ],
    row2: [
      "Field Experimentation & OutSoursing Activities",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row3: [
      "NRSC Manpower",
      "2.5",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "0.0",
      "0.0",
      "27.8",
    ],
    row4: [
      "Project Scientists",
      "0.0",
      "23.9",
      "23.9",
      "23.9",
      "23.9",
      "23.9",
      "0.0",
      "0.0",
      "119.4",
    ],
    row5: [
      "Data Analysis",
      "3.0",
      "6.0",
      "6.0",
      "6.0",
      "6.0",
      "6.0",
      "0.0",
      "0.0",
      "33.0",
    ],
    row6: [
      "Hardware & Software + Maintenance",
      "17.0",
      "37.0",
      "11.0",
      "3.6",
      "3.6",
      "3.6",
      "0.0",
      "0.0",
      "75.8",
    ],
    row7: [
      "ALT DEM / High Resolution Satellite DEM Generation",
      "0.0",
      "0.0",
      "360.0",
      "360.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "720.0",
    ],
    row8: [
      "Travel & Field Works",
      "1.0",
      "4.0",
      "4.0",
      "4.0",
      "5.0",
      "5.0",
      "0.0",
      "0.0",
      "23.0",
    ],
    row9: [
      "Training & Workshops",
      "0.0",
      "4.0",
      "8.0",
      "8.0",
      "2.0",
      "2.0",
      "0.0",
      "0.0",
      "24.0",
    ],
    row10: [
      "Sub - Total 1",
      "43.3",
      "229.9",
      "567.9",
      "410.5",
      "45.5",
      "45.5",
      "0.0",
      "0.0",
      "3142.7",
    ],
    row11: [
      "Project Management @ 5% of Sub - Total 1",
      "2.2",
      "11.5",
      "28.4",
      "20.5",
      "2.3",
      "2.3",
      "0.0",
      "0.0",
      "67.1",
    ],
    row12: [
      "Sub - Total 2",
      "45.5",
      "241.4",
      "596.3",
      "431.1",
      "47.8",
      "47.8",
      "0.0",
      "0.0",
      "1409.9",
    ],
    row13: [
      "Organization Overheads @ 5% of Sub - Total 2",
      "2.3",
      "12.1",
      "29.8",
      "21.6",
      "2.4",
      "2.4",
      "0.0",
      "0.0",
      "70.5",
    ],
    row14: [
      "Grand Total",
      "47.7",
      "253.5",
      "626.1",
      "452.6",
      "50.2",
      "50.2",
      "0.0",
      "0.0",
      "1480.4",
    ],
  },
};

export default class FLFinancialProposal extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
          height: "800px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          <div className="card" style={{ flexGrow: "1", overflowX: "auto" }}>
            <MediaQuery minWidth={991}>
              <div
                className="card-body"
                style={{ margin: "auto", padding: "10px" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Glacial Lake Outburst Flood (GLOF) Risk Assessment of Glacial
                  Lakes in the Himalayan Region of Indian River Basins
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <div className="card-body" style={{ padding: "10px" }}>
                <h3 align="center" style={{ color: "#002171" }}>
                  Glacial Lake Outburst Flood (GLOF) Risk Assessment of Glacial
                  Lakes in the Himalayan Region of Indian River Basins
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
